import { render, staticRenderFns } from "./ModalHeader.vue?vue&type=template&id=41b45dc7&"
import script from "./ModalHeader.vue?vue&type=script&setup=true&lang=ts&"
export * from "./ModalHeader.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports